export const CBP_CROSS_ORIGIN_BASE = 'https://rulings.cbp.gov/search?term={term}&collection=ALL&commodityGrouping=ALL&sortBy=RELEVANCE&pageSize=30&page=1';